import ENDPOINT from "./endpoints";
import ROLES from "./roles";

export { ENDPOINT, ROLES };
